import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useForm, useWatch } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import StockValuationDetailTable from "../Reusable/StockValuationTableDetail";
import Filter from "./Filter";

import moment from "moment";
import Button from "../Reusable/Button";

const columns: ColumnDef<any, any>[] = [
  {
    accessorKey: "account_name",
    header: "Account Name",
  },
  {
    accessorKey: "debit",
    header: "Debit",
  },
  {
    accessorKey: "credit",
    header: "Credit",
  },
];

export default () => {
  const { download } = useDownload();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });
  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: [`stock-valuation-${JSON.stringify(formValues)}`],
    url: `${APIS.PRODUCT}valuation-detail/`,
    params: {
      ...formValues,
    },
  });

  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={tw`space-y-2`}>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end `}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <StockValuationDetailTable data={data} isLoading={isDataLoading} />
    </div>
  );
};

